/**
 * Wilson 95% confidence interval for a binomial proportion.
 *
 * Used by the Results page to qualify win-rate headlines: the CI bounds give
 * the reader a sense of how much an N-vote aggregate can shift once more
 * votes come in. Returns null when there are zero decided votes — there's
 * no meaningful proportion to bound.
 */

export interface WilsonCI {
  lower: number;
  upper: number;
}

export function wilson(wins: number, decided: number): WilsonCI | null {
  if (decided === 0) return null;
  const z = 1.96;
  const p = wins / decided;
  const n = decided;
  const denom = 1 + (z * z) / n;
  const center = (p + (z * z) / (2 * n)) / denom;
  const half = (z * Math.sqrt((p * (1 - p)) / n + (z * z) / (4 * n * n))) / denom;
  return {
    lower: Math.max(0, center - half),
    upper: Math.min(1, center + half),
  };
}
